// import { Checkbox, FormControlLabel } from '@mui/material'
import copy from 'copy-to-clipboard'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
// import InputField from '../../common/InputMUI'

import Alerts from '../../../Popups/SidePopup'
import { getCustomLinkByLoanId } from '../../CommunityActionCreator'

const CustomLinkPrevious = ({ handler, loanId }) => {
    const [allData, setAllData] = useState({
        id: '', loanId: '', linkId: '', url: '', expiryTime: '',
        createdAt: '', dataMask: '', documentVisible: '', activityVisible: '', name: ''
    })
    const [message, setMessage] = useState({})
    const [alertPopup, setAlertPopup] = useState(false)
    const [msg, setMsg] = useState('')

    const removePopup = () => {
        setTimeout(
            function () {
                setAlertPopup(false)
            }.bind(this),
            5000
        );
    }
    useEffect(() => {
        if (loanId) {
            getLinks(loanId)
        }

    }, [])
    const NewCopy = (data) => {
        copy(data)
        setMsg('Link copied to the clipboard!')
        setAlertPopup(true)
        removePopup()
    }
    const getLinks = (loanId) => {
        getCustomLinkByLoanId(loanId, callback => {
            if (callback.message === "success") {
                setAllData(callback.data)
            }
        }, error => {

        })
    }

    return (
        <div className="background-blur-external" style={{ zIndex: '9999' }}>
            <div className='delete-popup-main' style={{ height: '90%', width: '80%' }}>
                <h2 className='mb-3'>Previous Custom Links</h2>
                <hr />
                <div className='table-responsive full-height'>
                    {
                        <>
                            <div style={{ overflow: 'auto', height: '80%' }}>
                                <table className='table credhub-table mt-2' style={{ scroll: "auto" }}>
                                    <thead>
                                        <tr>
                                            <th scope='col'>Name</th>
                                            <th scope="col">Url</th>
                                            <th scope="col">Status</th>
                                            <th scope='col'>Copy</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {allData && allData.length > 0 ?
                                            allData.map((data, i) => {
                                                var date1 = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
                                                var date2 = moment(data.expiryTime).format('YYYY-MM-DD HH:mm:ss');
                                                return (
                                                    <tr key={i}>
                                                        <td>{data.name}</td>
                                                        <td style={{ overflow: "hidden" }}>{data.url}</td>
                                                        <td>{date1 > date2 ? <b className='text-danger'>Expired</b>
                                                            : <b className='text-success'>Available</b>}</td>
                                                        <td><i className='fa fa-copy' style={{ fontSize: '18px', color: 'green', cursor: 'pointer' }}
                                                            onClick={() => NewCopy(data.url)}></i></td>
                                                    </tr>
                                                )
                                            }) : <h3>No Data Found!!</h3>}

                                    </tbody>
                                </table>
                            </div>
                            <div className="text-center">
                                <button type="button" className="cred-btn" onClick={e => handler()}>Close</button>
                            </div>
                            {/* <Pagination
                                paginationHandlerNew={paginationHandlerNew}
                                totalCount={totalCount}
                                paginationHandler={paginationHandler}
                                pageNumber={pageNumber}
                                noOfRows={noOfRows}
                            /> */}      
                        </>
                    }


                </div>
                {
                alertPopup ?
                    <Alerts msg={msg} />
                    : ""
            }
            </div>

            
        </div >
    )
}

export default CustomLinkPrevious;